import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { deleteQuote } from '../api/quotesApi';

// Server broadcasts UpdateQuoteTable on success so useQuotes self-invalidates.
// Per-id ['quote', id] cache is left alone — the caller navigates away on
// success and the next visit refetches naturally.
export default function useDeleteQuote() {
    return useMutation({
        mutationFn: deleteQuote,
        onSuccess: () => toast.success('Quote deleted'),
        onError: (err) => toast.error(err?.message ?? 'Failed to delete quote'),
    });
}
